import React from "react";
import { GoogleCalendarFeed } from "./GoogleCalendarImporter";
import Select from "react-select";
import { CALENDARS } from "./CALENDARS";
import { colourStyles } from "./AppColors";

interface SchoolSelectorProps {
  onUpdate: (selected: GoogleCalendarFeed[]) => void;
  selected: GoogleCalendarFeed[];
}
export const SchoolSelector: React.SFC<SchoolSelectorProps> = (props) => {
  console.log(`SchoolSelector`, props.selected);
  return (
    <div id="calendar-school-selector" style={{ marginBottom: "1rem" }}>
      <Select
        options={CALENDARS}
        onChange={(i) => props.onUpdate(i as GoogleCalendarFeed[])}
        getOptionLabel={(option: GoogleCalendarFeed) => option.title}
        getOptionValue={(option: GoogleCalendarFeed) => option.slug}
        className="school-selector"
        classNamePrefix="hfcs-select"
        placeholder={"Select Calendars"}
        isMulti={true}
        defaultValue={props.selected}
        isClearable={false}
        // menuPortalTarget={document.getElementById('calendar-app')}
        styles={colourStyles}
        // defaultMenuIsOpen={true}
      />
    </div>
  );
};
